export const checkIfCityLimitModeEnabled = (mode) => /yes_city/i.test(mode);
//# sourceMappingURL=checkIfCityLimitModeEnabled.js.map